<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Login form</v-toolbar-title>
            <!--                <v-spacer></v-spacer>-->
            <!--                <v-tooltip bottom>-->
            <!--                  <template v-slot:activator="{ on }">-->
            <!--                    <v-btn :href="source" icon large target="_blank" v-on="on">-->
            <!--                      <v-icon large>code</v-icon>-->
            <!--                    </v-btn>-->
            <!--                  </template>-->
            <!--                  <span>Source</span>-->
            <!--                </v-tooltip>-->
            <!--                <v-tooltip right>-->
            <!--                  <template v-slot:activator="{ on }">-->
            <!--                    <v-btn icon large href="https://codepen.io/johnjleider/pen/wyYVVj" target="_blank" v-on="on">-->
            <!--                      <v-icon large>mdi-codepen</v-icon>-->
            <!--                    </v-btn>-->
            <!--                  </template>-->
            <!--                  <span>Codepen</span>-->
            <!--                </v-tooltip>-->
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="person"
                v-model="username"
                label="Login"
                :error-messages="usernameErrors"
                required
                @input="$v.username.$touch()"
                @blur="$v.username.$touch()"
                v-on:keyup.enter="$refs.loginButton.$el.click()"
                ref="userEmailInputField"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                v-model="password"
                required
                :error-messages="passwordErrors"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                v-on:keyup.enter="$refs.loginButton.$el.click()"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <!-- <v-btn @click="signUpUser">Sign Up</v-btn> -->
            <v-btn @click="recoverPassword">Recover</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="authenticateUser" ref="loginButton">
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <ErrorDialog
      v-if="$store.state.errors.length > 0"
      :showDialog="$store.state.errors.length > 0"
      :errors="$store.state.errors"
    ></ErrorDialog>
  </v-container>
</template>

<script>
import ErrorDialog from '../components/ErrorDialog'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  components: {
    ErrorDialog
  },
  data: () => ({
    drawer: null,
    username: '',
    password: ''
  }),
  methods: {
    authenticateUser: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('AuthStore/authenticateUser', {
          username: this.username,
          password: this.password
        })
      }
    },
    signUpUser: function() {
      this.$store.dispatch('AuthStore/signUpInit')
    },
    recoverPassword: function() {
      this.$store.dispatch('AuthStore/resetPasswordInit')
    },
    focusField: function() {
      this.$nextTick(this.$refs.userEmailInputField.focus)
    }
  },
  props: {},
  computed: {
    usernameErrors() {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.email && errors.push('Must be valid login')
      !this.$v.username.required && errors.push('Login is required')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      !this.$v.password.minLength &&
        errors.push('Password must be at leas 6 characters')
      return errors
    }
  },
  validations: {
    username: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(5)
    }
  },
  mounted: function() {
    this.focusField()
  }
}
</script>
